module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAAQCAYAAADwMZRfAAAACXBIWXMAAAsSAAALEgHS3X78AAAAzklEQVQ4y6WTwRWCQAxEPzwLoAO1AulAjrlaAVKBJYidYAccc7QE6AA7wArwEnyAAovkusnf7Mys1zQNa2szdaiqOyADHiKSjvX5M5ekwBG4GnAZxIbiAXDxJsOheGwbryusqkZAAETA5Ud/aRoVQCUi1QeiqgVw+NOcU/ucYI3FLSS0VZdWIiK5DyAitelQLgRkPXc6oJcD4NYCviw2UO0AKeZysnWAhKMQy4lLRVObDBN5B/ZAAjzH+oa/uDJhcyBtE2kpzVT1bN+hp8kbn5hCl3r1tgYAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/gray_star.png
// module id = nO62
// module chunks = 1